// extracted by mini-css-extract-plugin
export var dividerContainer = "_97-0";
export var line = "_97-1";